
import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { getIntegralExchange, getIntegralRule } from '@/services/http';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import IntegralRule from '@/components/rule/integralRule.vue';
import { readCookie } from '@/tools/tools';

@Component({
  components: {
    Header,
    Footer,
    NavMenu,
    IntegralRule
  }
})
export default class extends Vue {
  @Action('user/setUserInfoList') setUserInfoList!: Function

  @State('user') userInfo: any; // 用户信息

  loading: boolean = false; // 加载

  integralExchange: any[] = []; // 积分商品列表

  isLoading: boolean = false; // 表格加载

  ruleList: any[] = []; // 积分规则列表

  totalnumber: number = 0; // 总条数

  pageNo: number = 1; // 当前页

  pageSize: number = 12; // 当前条数

  showRule: boolean = false; // 是否显示规则说明

  private created() {
    this.setUserInfoList();
    this.getIntegralExchangeExchange(); // 积分兑换列表
    this.getIntegralRule(); // 积分规则列表
  }

  // 积分规则列表
  private async getIntegralRule() {
    const res: any = await getIntegralRule({
      companyId: 1
    });
    if (res.data.code === 100) {
      this.ruleList = res.data.data.ruleList;
    } else {
      this.$message.error(res.data.message);
    }
  }

  // 条数回调
  private handleSizeChange(pageSize: number) {
    this.pageSize = pageSize;
    this.getIntegralExchangeExchange();
  }

  // 页数回调
  private handleCurrentChange(pageNo: number) {
    this.pageNo = pageNo;
    this.getIntegralExchangeExchange();
  }

  // 获取积分兑换列表
  private async getIntegralExchangeExchange() {
    const anchor = readCookie('anchor');
    const res: any = await getIntegralExchange({
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      companyId: 1,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : ''
    });
    if (res.data && res.data.code === 100) {
      this.totalnumber = res.data.data.total;
      this.integralExchange = res.data.data.list ? res.data.data.list : [];
      this.integralExchange = this.integralExchange.map((item: any) => {
        const data: any = item;
        if (data.lowest_price.split(',')[0]) {
          // const lowPrice = data.lowest_price.split(',')[0].split('.')[0];
          // const lowPrice2 = data.lowest_price.split(',')[0].split('.')[1];
          // data.lowPrice = (lowPrice - data.discount_amount) >= 0 ? (lowPrice - data.discount_amount) : 0;
          // data.lowPrice2 = lowPrice2;
          const lowPrice = ((data.lowest_price.split(',')[0] || data.lowest_price) - data.discount_amount).toFixed(2).toString();
          data.lowPrice = lowPrice.substring(0, lowPrice.indexOf('.'));
          data.lowPrice2 = lowPrice.substring(lowPrice.indexOf('.') + 1, lowPrice.length);
        }
        return data;
      });
    }
  }
}

